var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 31,
    viewBox: "0 0 16 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC700",
    d: "M13.58 14.356H5.336v-3.632c0-2.177 1.846-3.94 4.122-3.94 2.277 0 4.122 1.763 4.122 3.94v3.632zM5.336 21.586L13.58 21.586 13.58 14.951 5.336 14.951zM5.336 28.816L13.58 28.816 13.58 22.18 5.336 22.18zM11.351 3.857c-.114-.304-.303-.572-.55-.784l2.433-1.343c.33-.183.444-.587.253-.902l-.345-.572L8.58 2.774c-.672.313-1.14.967-1.14 1.73 0 1.066.903 1.93 2.018 1.93.865 0 1.598-.525 1.885-1.256h2.493c.382 0 .69-.296.69-.66v-.66h-3.175z",
    transform: "translate(.026 .537)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303BA6",
    d: "M6.78 4.157c-2.291 0-4.155 1.782-4.155 3.973v9.522c-.334.14-.583.436-.634.8L.801 25.61h3.323v-7.023c0-.456-.314-.837-.745-.97V8.13c0-1.793 1.526-3.252 3.402-3.252.208 0 .376-.161.376-.36 0-.2-.168-.36-.376-.36",
    transform: "translate(.026 .537)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.a4987100ceb43d14d99a56156e65c05a.svg";
export { ForwardRef as ReactComponent };